import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClient: HttpClient) {
  }

  getAll() {
    return this.httpClient.get(environment.API_URL + '/users/getUsers',
      { responseType: 'json' });
  }
  getAllByMeeting(meetingId) {
    return this.httpClient.get(environment.API_URL + '/users/meetingAttendance/' + meetingId,
      { responseType: 'json' });
  }
  getMeetingAttendance(meetingId) {
    return this.httpClient.get(environment.API_URL + '/attendances/findAttendancesByMetting/' + meetingId, { responseType: 'json' });
  }
  getById(id) {
    return this.httpClient.get(environment.API_URL + '/users/getUserById/' + id,
      { responseType: 'json' });
  }
  getActiveUsers() {
    return this.httpClient.get(environment.API_URL + '/users/getUsers/active',
      { responseType: 'json' });
  }
  getByType(type: string) {
    return this.httpClient.get(environment.API_URL + '/users/userType/' + type,
      { responseType: 'json' });
  }
  getCurrentUser() {
    return this.httpClient.get(environment.API_URL + '/auth/current',
      { responseType: 'json' });
  }
  create(user) {
    return this.httpClient.post(environment.API_URL + '/users/registerNewUser', user,
      { responseType: 'json' });
  }
  update(id, user) {
    return this.httpClient.put(environment.API_URL + '/users/userSelfModify/' + id, user,
      { responseType: 'json' });
  }
  adminUpdateUser(id, user) {
    return this.httpClient.put(environment.API_URL + '/users/adminModifyUser/' + id, user,
      { responseType: 'json' });
  }
  delete(userId) {
    return this.httpClient.delete(environment.API_URL + '/users/removeUser/' + userId,
      { responseType: 'json' });
  }
  updatePassword(passwords) {
    return this.httpClient.post(environment.API_URL + '/users/resetPassword',
      { responseType: 'json' });
  }
  forgotPassword(email) {
    return this.httpClient.post(environment.API_URL + '/auth/initiate-reset-password', email,
      { responseType: 'json' });
  }
  resetPassword(email) {
    return this.httpClient.post(environment.API_URL + '/auth/reset-password', email,
      { responseType: 'json' });
  }
  uploadSignature(userId, signature: FormData, headers) {
    return this.httpClient.put(environment.API_URL + '/users/attachSignatureDocument/' + userId, signature, { headers });
  }
  changePasswordCredentials(userId, passwords) {
    return this.httpClient.put(environment.API_URL + '/users/changeCredentials/' + userId, passwords);

  }
}

